import { BaseEventEmitter } from "./baseEventEmitter";

export class SimpleEventEmitter<Events extends Record<string, any>> extends BaseEventEmitter<Events> {
  constructor() {
    super();
  }
}
